const data = [
  {
    title: "GitHub User Search",
    shortDescription:
      "See how React 'talks' to the internet. Type a username to fetch their real-time profile data.",
    description:
      "This project introduces the most critical skill in web development: Working with APIs. Think of this component like a digital ID card printer. When you type a name and hit search, your app sends a request to GitHub's servers (the API). GitHub replies with a packet of data (JSON) containing the user's photo, bio, and stats. This project teaches you how to handle the 'waiting time' (loading states) and what to do if the user doesn't exist (error handling).",
  },
];

export default data;